import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import LogoDW from '../vectors/logo-dw';
import classes from './navigation.module.css';
import CC from '../scripts/combine-classes';

const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const menuRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const checkMobile = () => {
      const dRect =  document.documentElement.getBoundingClientRect();
      setIsMobile(dRect.width < 768);
    }

    const clickHandler = (event: MouseEvent) => {
      if (event.target !== null && !menuOpen) {
        const target: HTMLElement = event.target as HTMLElement;
        if (!(menuRef.current && menuRef.current.contains(target))) {
          setMenuOpen(false);
        }
      }
    }

    checkMobile();

    window.addEventListener('resize', checkMobile);
    window.addEventListener('click', clickHandler);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('click', clickHandler);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.container}>
      <nav className={classes.nav}>
        <div className={classes.logoVersion}>
          <Link to="/damien-watson" className={classes.logo}>
            <LogoDW primary="#fff" secondary="#316293" />
          </Link>
          <span>v0.9</span>
        </div>
        <div className={CC(
          classes.menu,
          { [classes.menuOpen]: menuOpen },
          { [classes.mobile]: isMobile },
          { [classes.desktop]: !isMobile },
        )}>
          <button
            ref={menuRef}
            type="button"
            className={CC(
              classes.icon,
              { [classes.isMobile]: isMobile },
            )}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
          </button>
          <ul>
            <Link to="/damien-watson/work">Work</Link>
            <Link to="/damien-watson/projects">Projects</Link>
            <Link to="/damien-watson/sandbox">Sandbox</Link>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Navigation;
